window.PackAndMoveElevatorModal = {

    init() {

        this.modal = document.querySelector(
            "[data-pack-and-move-elevator-modal]"
        );

        if (!this.modal) return;

        this.productId =
            this.modal.dataset.elevatorProductId || "";

        this.variantId =
            this.modal.dataset.elevatorVariantId || "";

        this.checkbox = this.modal.querySelector(
            "[data-elevator-agree]"
        );

        this.confirm = this.modal.querySelector(
            "[data-elevator-confirm]"
        );

        this.cancel = this.modal.querySelector(
            "[data-elevator-cancel]"
        );

        this.overlay = this.modal.querySelector(
            "[data-modal-close]"
        );

        this.bind();

    },

    bind() {

        this.checkbox.addEventListener("change", () => {

            this.confirm.disabled =
                !this.checkbox.checked;

        });

        this.confirm.addEventListener("click", () => {

            const booking = window.packAndMoveBooking;

            if (!booking) return;

            booking.elevator = {

                required: true,

                confirmed: true,

                productId: this.productId,

                variantId: this.variantId,

                title:
                    this.modal.dataset.elevatorTitle,

                displayPrice:
                    this.modal.dataset.elevatorPrice,

                rawPrice:
                    Number(this.modal.dataset.elevatorPriceRaw)

            };

            console.log(
                "Elevator Charge:",
                booking.elevator
            );

            this.close();
            window.PackAndMoveBookNow.submit();

        });

        this.cancel.addEventListener("click", () => {

            this.close();

        });

        this.overlay.addEventListener("click", () => {

            this.close();

        });

    },

    open() {

        this.checkbox.checked = false;

        this.confirm.disabled = true;

        this.modal.hidden = false;

        document.body.classList.add(
            "pack-and-move-modal-open"
        );

    },

    close() {

        this.modal.hidden = true;

        document.body.classList.remove(
            "pack-and-move-modal-open"
        );

    }

};

document.addEventListener("DOMContentLoaded", () => {

    window.PackAndMoveElevatorModal.init();

});